import classNames from "classnames";
import { useEffect, useState } from "react";
import Icon, { COLORS, ICONS } from "../../../../../../../general-ui/icon";
import Switch from "../../../../../../../general-ui/switch/switch";
import google from '../../../../../../../../images/logos/Google.svg';
import facebook from '../../../../../../../../images/logos/FB.svg';
import linkedin from '../../../../../../../../images/logos/Li.svg';
import { useDispatch, useSelector } from "react-redux";
import { EventsState } from "../../../../../../../../store/types";
import { setRegistrationFeature, setRegistrationSingleSignOn } from "../../../../../../../../store/actions/admin/create-event";
import { SingleSignOnTypes } from "../../../../../../../../types/working-model";

export function SingleSignOnIcon({ type }: { type: SingleSignOnTypes }): JSX.Element {
    switch (type) {
        case SingleSignOnTypes.Google: return <img className="sign-on-logo google-icon" src={google} alt="" />;
        case SingleSignOnTypes.Facebook: return <img className="sign-on-logo facebook-icon" src={facebook} alt="" />;
        case SingleSignOnTypes.LinkedIn: return <img className="sign-on-logo linkedin-icon" src={linkedin} alt="" />;
        default: return <></>;
    }
}

const SingleSignOn: React.FC = () => {
    const {
        CreateEventReducer: {
            workingEvent
        },
    } = useSelector((state: EventsState) => state);
    const isSingleSignOn = !!workingEvent?.registration_settings?.enableSocial;
    const currentSignOns = workingEvent?.registration_settings?.singleSignOns || [];
    const [showSingleSignOn, setShowSingleSignOn] = useState(true);
    const [singleSignOns, setSingleSignOns] = useState<Set<SingleSignOnTypes>>(new Set(currentSignOns));

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setRegistrationSingleSignOn(Array.from(singleSignOns)));
    }, [singleSignOns, dispatch]);

    const setIsSingleSignOn = (isOn: boolean) => {
        if (isOn) {
            setShowSingleSignOn(true);
        }
        dispatch(setRegistrationFeature("enableSocial", isOn));
    };

    const handleSignOns = (social: SingleSignOnTypes) => {
        const newSet = new Set(singleSignOns);
        singleSignOns.has(social) ? newSet.delete(social) : newSet.add(social);
        setSingleSignOns(newSet);
    };

    return (
        <>
            <div className="settings-card">
                <label>
                    {isSingleSignOn && (
                        <button className={classNames("no-style", { show: showSingleSignOn })} onClick={() => setShowSingleSignOn(prev => !prev)}>
                            <Icon name={ICONS.KEYBOARD_ARROW_RIGHT} size={12} color={COLORS.WHITE} />
                        </button>
                    )}
                    Single sign on
                </label>
                <Switch
                    value={"Single sign on"}
                    on={isSingleSignOn}
                    onClick={(_, isOn) => setIsSingleSignOn(isOn)}
                />
            </div>
            {showSingleSignOn && isSingleSignOn && (
                <>
                    <div className="settings-card sub-list">
                        <label><SingleSignOnIcon type={SingleSignOnTypes.Google} />Google</label>
                        <Switch
                            value={SingleSignOnTypes.Google}
                            on={singleSignOns.has(SingleSignOnTypes.Google)}
                            onClick={handleSignOns}
                        />
                    </div>
                    <div className="settings-card sub-list">
                        <label><SingleSignOnIcon type={SingleSignOnTypes.Facebook} />Facebook</label>
                        <Switch
                            value={SingleSignOnTypes.Facebook}
                            on={singleSignOns.has(SingleSignOnTypes.Facebook)}
                            onClick={handleSignOns}
                        />
                    </div>
                    <div className="settings-card sub-list">
                        <label><SingleSignOnIcon type={SingleSignOnTypes.LinkedIn} />LinkedIn</label>
                        <Switch
                            value={SingleSignOnTypes.LinkedIn}
                            on={singleSignOns.has(SingleSignOnTypes.LinkedIn)}
                            onClick={handleSignOns}
                        />
                    </div>
                </>
            )}
        </>
    );
};

export default SingleSignOn;